module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "loadmore-demo",
    attrs: {
      "title": "Loadmore"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.code
    }
  }, [_c('Btn', {
    staticClass: "show-btn",
    on: {
      "click": function($event) {
        _vm.setShow(0)
      }
    }
  }, [_vm._v("Show")]), _vm._v(" "), (_vm.show[0]) ? _c('Loadmore', {
    attrs: {
      "done": _vm.cur >= _vm.total
    },
    on: {
      "load-method": _vm.getNextPage
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "block"
    }, [_vm._v("\n        List." + _vm._s(item) + "\n      ")])
  })) : _vm._e()], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "erroe",
      "description": "错误处理",
      "code": _vm.code
    }
  }, [_c('Btn', {
    staticClass: "show-btn",
    on: {
      "click": function($event) {
        _vm.setShow(2)
      }
    }
  }, [_vm._v("Show")]), _vm._v(" "), (_vm.show[2]) ? _c('Loadmore', {
    attrs: {
      "done": _vm.cur >= _vm.total
    },
    on: {
      "load-method": _vm.getNextPage
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "block"
    }, [_vm._v("\n        List." + _vm._s(item) + "\n      ")])
  })) : _vm._e()], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "slot",
      "description": "自定义Slot内容",
      "code": _vm.slot_code
    }
  }, [_c('Btn', {
    staticClass: "show-btn",
    on: {
      "click": function($event) {
        _vm.setShow(1)
      }
    }
  }, [_vm._v("Show")]), _vm._v(" "), (_vm.show[1]) ? _c('Loadmore', {
    attrs: {
      "done": _vm.cur >= _vm.total
    },
    on: {
      "load-method": _vm.getNextPage
    },
    scopedSlots: _vm._u([
      ["loadmore", function(props) {
        return [_c('Btn', {
          staticClass: "blue-btn",
          on: {
            "click": props.loadmore
          }
        }, [_vm._v("点击加载更多")])]
      }],
      ["error", function(props) {
        return [_c('Btn', {
          staticClass: "error-btn",
          on: {
            "click": props.loadmore
          }
        }, [_vm._v("出错啦，重新加载")])]
      }]
    ])
  }, [_vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "block"
    }, [_vm._v("\n        List." + _vm._s(item) + "\n      ")])
  }), _vm._v(" "), _c('template', {
    slot: "loading"
  }, [_c('Icon', {
    staticClass: "float-icon",
    attrs: {
      "name": "heart",
      "color": "rgb(255, 66, 66)"
    }
  }), _vm._v("\n        Loading more...\n      ")], 1)], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-714c7a0f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Loadmore.vue
// module id = 675
// module chunks = 0